<template>
  <div>
    <div class="app-info" v-if="!isLoggedIn">
      <h2 class="app-info__title">Prijavi se!</h2>
      <div class="content-wrapper">
        <div class="benefits">
          <div class="info app-info__feature intersect--fly-in">
            <img src="@/assets/icons/schedule.svg" class="info__icon" />
            <h2 class="info__title">Personalizirani raspored</h2>
            <p class="info__description">
              Označi predavanja i panel rasprave na kojima ćeš sudjelovati, stvori osobni raspored.
            </p>
          </div>
          <div class="info app-info__feature intersect--fly-in">
            <img src="@/assets/icons/network.svg" class="info__icon" />
            <h2 class="info__title">Networking</h2>
            <p class="info__description">
              Prijavi se na fly talks i radionice, upoznaj i poveži se s potencijalnim budućim poslodavcima.
            </p>
          </div>
          <div class="info app-info__feature intersect--fly-in">
            <img src="@/assets/icons/rewards.svg" class="info__icon" />
            <h2 class="info__title">Brojne nagrade</h2>
            <p class="info__description">Sudjelovanjem na konferenciji skupljaj bodove, osvoji vrijedne nagrade.</p>
          </div>
          <div class="info app-info__feature intersect--fly-in">
            <img src="@/assets/icons/bell.svg" class="info__icon" />
            <h2 class="info__title">Najnovije informacije</h2>
            <p class="info__description">Osiguraj pristup svim novim informacijama, ne propusti važne obavijesti.</p>
          </div>
          <button v-show="!isLoggedIn" class="app-info__cta cta--primary" v-on:click="$emit('showLoginModal')">
            Prijavi se
          </button>
        </div>
        <div class="image-wrapper">
          <img src="@/assets/visuals/phone.png" alt="Phone" class="app-info__image" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppInfo',
  computed: {
    isLoggedIn: function() {
      let token = localStorage.getItem('token');
      if (!token) return false;

      let decoded = this.$decode(token);

      if (!decoded) return false;

      return true;
    },
  },
  methods: {
    isAdmin: function() {
      let token = localStorage.getItem('token');
      if (!token) return false;

      let decoded = this.$decode(token);

      if (!decoded) return false;

      if (decoded.roles === 'Administrator') return true;

      return false;
    },
    toggleBodyOverflow: function() {
      if (window.innerWidth < 1024) document.body.classList.add('no-scroll');
      else document.body.classList.remove('no-scroll');
    },
    routeToApp: function() {
      this.isAdmin() ? this.$router.push('admin') : this.$router.push('app');
    },
  },
};
</script>

<style scoped>
.app-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  max-width: 1440px;
  margin: auto;
  padding: 157px 205px 0 205px;
  align-items: flex-start;
}

.app-info__title {
  width: 100%;
  font-size: 32px;
  line-height: 58px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 60px;
  text-align: center;
}

.image-wrapper {
  position: sticky;
  top: 0;
  align-self: flex-start;
  margin-right: -205px;
}

.image-wrapper img {
  width: 100%;
}

.content-wrapper {
  display: flex;
}

.benefits {
  width: 400px;
}

.contact__buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
}

.app-info__feature,
.app-info__cta {
  margin-top: 48px;
}

.app-info__feature {
  max-width: 230px;
}

.info {
  margin-top: 48px;
  position: relative;
}

.info__title {
  color: #fff;
  font-size: 24px;
  line-height: 36px;
  font-weight: 800;
  margin-bottom: 8px;
}

.info__description {
  color: #ffffffcc;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  max-width: 280px;
}

.info__content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.info__icon {
  width: 40px;
  height: 40px;
  position: absolute;
  left: -24px;
  top: -8px;
  z-index: -1;
}

@media screen and (max-width: 768px) {
  .app-info {
    padding-top: 128px;
    align-items: unset;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
  }

  .content-wrapper {
    flex-direction: column-reverse;
  }

  .image-wrapper {
    position: initial;
    margin-right: 0;
  }

  .benefits {
    width: unset;
    margin: auto;
  }
}

@media screen and (min-width: 360px) {
  .app-info__feature {
    max-width: unset;
  }
}

@media screen and (min-width: 1180px) {
  .info {
    margin-top: 0;
  }

  .app-info__title {
    font-size: 48px;
  }

  .info__title {
    font-size: 28px;
    line-height: 38px;
    margin-bottom: 16px;
  }

  .info__description {
    line-height: 24px;
  }

  .info__icon {
    width: 64px;
    height: 64px;
    left: -38px;
    top: -28px;
  }
}

@media screen and (min-width: 1080px) {
  .app-info__feature {
    margin-top: 106px;
  }

  .app-info__cta {
    margin-top: 80px;
  }
}
</style>
